export default {
  title: 'You are going to complete the {{entityTitle}}',
  subTitle: 'Please specify the completion date of the {{entityTitle}}',
  inputTitle: 'Completed date',
  completeButton: 'Complete',
  cancelButton: 'Cancel',
};
